
export const mutedHeaderStyles = {
  display: 'inline-block',
  fontWeight: '350'
};
